import { createTheme } from 'office-ui-fabric-react';

const themeDarkAlt = process.env.REACT_APP_KSHS_CLIENT ? '#0B4554' : '#337dc4';
const themePrimary = process.env.REACT_APP_KSHS_CLIENT ? '#005971' : '#003a72';
const themeDark = process.env.REACT_APP_KSHS_CLIENT ? '#0B4554' : '#002d57'

const defaultPalette = {
  themePrimary:            themePrimary,
  themeLighterAlt:         '#eff5f9',
  themeLighter:            '#c3d7e9',
  themeLight:              '#95b6d5',
  themeTertiary:           '#4479ab',
  themeSecondary:          '#104c84',
  themeDarkAlt:            themeDarkAlt,
  themeDark:               themeDark,
  themeDarker:             '#002140',
  neutralLighterAlt:       '#faf9f8',
  neutralLighter:          '#f3f2f1',
  neutralLight:            '#edebe9',
  neutralQuaternaryAlt:    '#e1dfdd',
  neutralQuaternary:       '#d0d0d0',
  neutralTertiaryAlt:      '#c8c6c4',
  neutralTertiary:         '#a19f9d',
  neutralSecondary:        '#605e5c',
  neutralSecondaryAlt:     '#8a8886',
  neutralPrimaryAlt:       '#3b3a39',
  neutralPrimary:          '#323130',
  neutralDark:             '#201f1e',
  black:                   '#000000',
  white:                   '#ffffff',
  blue:                    '#337dc4',
  lightBlue:               '#003a72',
  greyLight:               '#767676',
  greyMedium:              '#CDCDCD',
  greyUltraLight:          '#A6A6A6',
  light:                   '#E9E9E9',
  ultraLight:              '#F4F4F4',
  pageTitleGrey:           '#5F5D5B',
  borderLightGrey:         '#DBDBDB',
  borderGrey:              '#EDEBE9',
  borderDarkGrey:          '#8A8886',
  searchHighlighted:       '#FFF0C1',
  activeSearchHighlighted: '#D7B79D',
  red:                     '#D13438',
  grey1:                   '#DDDDDD',
  grey2:                   '#EEEEEE',
  grey3:                   '#605e5c',
};

export const fluentTheme = createTheme({ palette: defaultPalette, defaultFontStyle: { fontFamily: 'Golos Text' } });

export const theme = {
  layout: {
    navTopPanelHeight:            42,
    exportFileBlockHeight:        48,
    presetsModuleHeight:          52,
    headerHeight:                 48,
    drivingControlTopPanelHeight: 42,
    sidebarWidth:                 255,
  },
  colors: defaultPalette,
};